// The worker screen policies the employee portal checks (GET /me/policies).
export const WORKER_POLICY = {
  // Personal profile
  PERSONAL_DETAILS_UPDATE: 'WorkerEditPersonalDetails',
  CONTACT_DETAILS_UPDATE: 'WorkerEditContactDetails',
  ADDRESS_UPDATE: 'WorkerEditAddress',
  BANK_DETAILS_UPDATE: 'WorkerEditBankDetails',
  HOLIDAY_PAY_DETAILS_SHOW: 'WorkerViewHolidayPay',

  // Work
  TIMESHEETS_CREATE: 'WorkerSubmitTimesheets',
  DOCUMENTS_CREATE: 'WorkerUploadDocuments',
  EXPENSE_CREATE: 'WorkerSubmitExpenses',
} as const;

export type WorkerPolicyKey =
  (typeof WORKER_POLICY)[keyof typeof WORKER_POLICY];
